(function () {
    'use strict';

    angular
        .module('app')
        .factory('HistoryService', HistoryService);

    HistoryService.$inject = ['$http', '$q', 'UrlService', 'DataService'];

    /**
     * @ngdoc service
     * @name HistoryService
     *
     * @description
     * Data service for history.
     */
    function HistoryService($http, $q, UrlService, DataService) {
        var dataSrv = DataService('history');

        var service = {
            getHistoryForItem: getHistoryForItem
        };

        return service;

        /**
         * Get history for the specified item.
         *
         * @param {object} params - Parameters object with the following properties:
         *   {number} masterRecordId - ID of the Item to fetch history for.
         *   {date} dateFrom
         *   {number} pageNumber
         *   {number} pageSize
         *
         * @return {promise}
         */
        function getHistoryForItem(params) {
            var queryParams = {
                MasterRecordId: params.masterRecordId,
                CurrentPage: params.pageNumber,
                PageSize: params.pageSize,
                UserId: params.userId,
                Operation: params.operation,
                Details: params.details
            };

            if (_.isDate(params.dateFrom)) {
                queryParams.DateFrom = params.dateFrom.toJSON();
            }

            return $http.get(UrlService.getWebAPIUrl() + '/history' + dataSrv.convertQueryParams(queryParams)).then(
                function (response) {
                    return response.data;
                });
        }
    }
})();